import { render, staticRenderFns } from "./Snow.vue?vue&type=template&id=0d901ad0&scoped=true&"
import script from "./Snow.vue?vue&type=script&lang=ts&"
export * from "./Snow.vue?vue&type=script&lang=ts&"
import style0 from "./Snow.vue?vue&type=style&index=0&id=0d901ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d901ad0",
  null
  
)

export default component.exports